<template>
  <section>
    <section v-if="isAgent">
      <div class="form-group">
        <div class="row">
          <div class="col-md-6 col-xs-12">
            <label class="inbox-label required">{{
              t("application.agent")
            }}</label>
            <input
              :fieldTitle="t('application.agent', {}, 'zh')"
              fieldname="agent"
              class="form-control"
              required
            />
          </div>
        </div>
      </div>
      <div class="form-group">
        <div class="row">
          <div class="col-md-12 col-xs-12">
            <label class="inbox-label">{{ t("application.remark") }}</label>
            <textarea
              :fieldTitle="t('application.remark', {}, 'zh')"
              fieldname="remark"
              class="form-control"
              style="max-width: 100%"
            />
          </div>
        </div>
      </div>
    </section>
<!--    <div class="form-group">-->
<!--      <div class="row">-->
<!--        <div class="col-md-6 col-xs-12">-->
<!--          <div class="row files">-->
<!--            <label class="col-8 col-xs-6 col-form-label">-->
<!--              <span>{{ t("application.hkid") }}</span>-->
<!--              <span class="text-danger">*</span>-->
<!--            </label>-->
<!--            <div class="col-4 col-xs-6 text-right">-->
<!--              <input-->
<!--                :fieldTitle="t('application.hkid', {}, 'zh')"-->
<!--                fieldname="hkidSoftCopy"-->
<!--                name="hkid"-->
<!--                type="file"-->
<!--                class="form-control"-->
<!--                required-->
<!--                accept="image/*,.pdf"-->
<!--              />-->
<!--              <button class="btn btn-secondary" type="button">-->
<!--                {{ t("form.upload_file") }}-->
<!--              </button>-->
<!--            </div>-->
<!--            <div class="selected-files" />-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->
<!--    <div class="form-group">-->
<!--      <div class="row">-->
<!--        <div class="col-md-6 col-xs-12">-->
<!--          <div class="row files multiple">-->
<!--            <label class="col-8 col-xs-7 col-form-label">-->
<!--              <span>{{ t("application.statement") }}</span>-->
<!--              <span class="text-danger">*</span>-->
<!--            </label>-->
<!--            <div class="col-4 col-xs-5 text-right">-->
<!--              <input-->
<!--                :fieldTitle="t('application.statement', {}, 'zh')"-->
<!--                fieldname="statementSoftCopy"-->
<!--                name="statement"-->
<!--                type="file"-->
<!--                multiple-->
<!--                class="form-control"-->
<!--                accept="image/*,.pdf"-->
<!--                required-->
<!--              />-->
<!--              <button class="btn btn-secondary" type="button">-->
<!--                {{ t("form.upload_file") }}-->
<!--              </button>-->
<!--            </div>-->
<!--            <div class="selected-files" />-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->
<!--    <div class="form-group">-->
<!--      <div class="row">-->
<!--        <div class="col-md-6 col-xs-12">-->
<!--          <div class="row files multiple">-->
<!--            <label class="col-9 col-sm-7 col-xs-7 col-form-label pr-0">-->
<!--              <span>{{ t("application.income_proof") }}</span>-->
<!--            </label>-->
<!--            <div class="col-3 col-sm-5 col-xs-5 text-right">-->
<!--              <input-->
<!--                :fieldTitle="t('application.income_proof', {}, 'zh')"-->
<!--                fieldname="incomeProofSoftCopy"-->
<!--                name="income_proof"-->
<!--                type="file"-->
<!--                class="form-control"-->
<!--                multiple-->
<!--                accept="image/*,.pdf"-->
<!--              />-->
<!--              <button class="btn btn-secondary" type="button">-->
<!--                {{ t("form.upload_file") }}-->
<!--              </button>-->
<!--            </div>-->
<!--            <div class="selected-files" />-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->
    <div>
      <div class="form-group">
        <label class="required">
          <span>{{ t("application.contact_time") }}</span>
        </label>
        <div class="row">
          <div class="col-6 col-md-6 col-xs-12">
            <label>
              <input
                type="radio"
                v-model="selectedDate"
                @change="contactDateChange"
                value="today"
                name="contact_date"
                required
              />{{ t("common.today") }}&nbsp;&nbsp;
            </label>
            <label>
              <input
                type="radio"
                v-model="selectedDate"
                @change="contactDateChange"
                value="tomorrow"
                name="contact_date"
                required
              />{{ t("common.tomorrow") }}&nbsp;&nbsp;
            </label>
            <label>
              <input
                type="radio"
                v-model="selectedDate"
                @change="contactDateChange"
                value="custom"
                name="contact_date"
                required
              />{{ t("common.other_date") }}
            </label>
            <input
              v-show="selectedDate === 'custom'"
              name="custom_date"
              required
              type="text"
              class="form-control datepicker"
              placeholder="yyyy-mm-dd"
            />
          </div>
          <div class="col-6 col-md-6 col-xs-12 time-section">
            <label>{{ t("application.contact_from") }}</label
            >&nbsp;
            <v-select
              :options="timeOptions"
              v-model="startTime"
              :reduce="(option) => option.code"
              :searchable="false"
              name="contact_from"
              required
            />
            <label>{{ t("application.contact_to") }}</label>
            <v-select
              :options="timeOptions"
              v-model="endTime"
              :reduce="(option) => option.code"
              :searchable="false"
              name="contact_to"
              required
            />
          </div>
        </div>
        <input
          type="hidden"
          :fieldTitle="t('application.contact_time', {}, 'zh')"
          fieldname="contactTime"
          name="contact_time"
        />
        <small style="margin-top: 10px">{{
          t("application.contact_tips")
        }}</small>
      </div>
    </div>
    <hr />
    <div
      class="form-group"
      style="max-height: 300px; overflow-y: auto; padding: 10px 0px"
    >
      <small v-html="t('application.terms', { companyName: companyName })" />
      <small
        v-if="checkTu"
        v-html="t('application.tu_terms', { companyName: companyName })"
      />
    </div>
    <div class="form-group text-right col-xs-12">
      <label class="col-form-label">
        {{ t("application.agree_terms") }}
        <input type="checkbox" name="terms" value="agree" required :checked="aggred"/>
      </label>
    </div>
  </section>
</template>
<script>
import moment from "moment";
import commonFunc from "~/assets/js/commonHelper.js";
export default {
  name: "Step4",
  props: {
    checkTu: {
      type: Boolean,
      default: false,
    },
    companyName: {
      type: String,
      default: "",
    },
    hkid: {
      type: String,
      default: "",
    },
    isAgent: {
      type: Boolean,
      default: false,
    },
    verifyMobile: {
      type: Boolean,
      default: false,
    },
    verifyEmail: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      selectedDate: "",
      customDate: "",
      startTime: "",
      endTime: "",
      timeOptions: [],
      mobileVerified: false,
      mobileVerifying: false,
      emailVerified: false,
      emailVerifying: false,
      phone: "",
      email: "",
      aggred: false,
    };
  },
  mounted() {
    const token = this.$route.query.token;
    if (token) {
      const applicationData = this.$store.state.search.applicationData;
      this.phone = applicationData.mobile;
      this.email = applicationData.email;
      this.selectedDate = "custom";
      this.customDate = applicationData.contactTime ? applicationData.contactTime.split(" ")[0] : "";
      const timeArray = applicationData.contactTime ? applicationData.contactTime.split(" ")[1].split("-") : ["", ""];
      this.startTime = timeArray[0];
      this.endTime = timeArray[1];
      this.aggred = true;
    } else {
      this.phone = this.$store.state.form.applicantInfo.mobile ? this.$store.state.form.applicantInfo.mobile.replace('+852', '') : '';
      this.email = this.$store.state.form.applicantInfo.email || '';
    }
    for (let i = 9; i <= 18; i++) {
      const t = i < 10 ? `0${i}:00` : `${i}:00`;
      this.timeOptions.push({ label: t, code: t });
    }
    this.$nextTick(function () {
      $(".datepicker").each(function (i) {
        $(this).datepicker({
          format: "yyyy-mm-dd",
        });
      });
    });
  },
  methods: {
    contactDateChange() {
      const date = moment();
      const currentDate = date.format("YYYY-MM-DD");
      if (this.selectedDate === "today") {
        $("input[name='custom_date']").val(currentDate);
      }
      if (this.selectedDate === "tomorrow") {
        const tomorrow = moment().add(1, "days");
        $("input[name='custom_date']").val(tomorrow.format("YYYY-MM-DD"));
      }
    },
    confirmAppointment() {
      const appointmentDetails = {
        selectedDate:
          this.selectedDate === "custom" ? this.customDate : this.selectedDate,
        startTime: this.startTime,
        endTime: this.endTime,
      };
      console.log("Appointment confirmed:", appointmentDetails);
    },
    mobileChange: async function (v) {
      if (commonFunc.isValidPhone(v)) {
        this.mobileVerifying = true;
        await this.$store.dispatch("form/verifiyMobile", {
          hkid: this.hkid !== "" ? this.hkid : $("input[name='identity']").val(),
          mobile: v,
        });
        const result = this.$store.state.form.isMobileVerified;
        this.mobileVerified = result;
        this.mobileVerifying = false;
      }
    },
    emailChange: async function (v) {
      if (commonFunc.isValidEmail(v)) {
        this.mobileVerifying = true;
        await this.$store.dispatch("form/verifiyEmail", {
          hkid: this.hkid !== "" ? this.hkid : $("input[name='identity']").val(),
          email: v,
        });
        const result = this.$store.state.form.isEmailVerified;
        this.emailVerified = result;
        this.emailVerifying = false;
      }
    },
  },
};
</script>
